import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
// import { environment } from '@src/environments/environment';
import { environment } from "../../environments/environment";
import { AppService } from './app.service';
export interface petKeyInfo {
  name: string,
  petKey: string,
  typeID: string,
  ForceFeeding: boolean,
  ForceMedication: boolean,
  ForceCardOnFile: boolean
  answers: Map<string,questions[]>
}
export interface forceControl {
  ForceFeeding: boolean,
  ForceMedication: boolean,
  ForceCardOnFile: boolean
}
export interface questions {
  reservationId: number,
  fullQuestion: number,
  question: { id: number },
  answer: string
}
@Injectable({
  providedIn: 'root'
})
export class InfoService {

  petKey: petKeyInfo[] = [];
  petType = [];

  ForceStepperControl: forceControl = {
    ForceFeeding: false,
    ForceMedication: false,
    ForceCardOnFile: false
  };

  // create appointment Data 
  appointmentObj;
  appointmentKey;
  userId;


  baseUrl = `${this.appService.userServiceUrl}/api/v2/`;
  // card
  baseCardUrl = `${this.appService.baseUrl}/payment-service/api/`
  basePath = this.appService.baseUrl.replace('services', '');
  // appKey = `${environment.applicationKey}`
  appKey = this.appService.applicationKey;
  // client = `${environment.tenantKey}`;
  client = this.appService.tenantKey;

  petId = '';
  petTypeId;
  selectedPurchaseType = '';
  listOfPets = [];
  userObj: any;

  feedSchUrl = '/petType/{PetTypeKey}/feed/feedSchedule?size=100&sort=orderId,asc';
  feedAmount = '/petType/{PetTypeKey}/feed/feedAmount?size=100&sort=orderId,asc';
  feedUnit = '/petType/{PetTypeKey}/feed/feedUnit?size=100&sort=orderId,asc';
  feedtype = '/petType/{PetTypeKey}/feed/feedType?size=100&sort=orderId,asc';
  feedmethod = '/petType/{PetTypeKey}/feed/feedMethod?size=100&sort=orderId,asc';

  MedicationUnit = '/petType/{PetTypeKey}/medication/unit?size=100&sort=orderId,asc';//
  MedicationAmount = '/petType/{PetTypeKey}/medication/amount?size=100&sort=orderId,asc';//
  MedicationType = '/petType/{PetTypeKey}/medication/type?size=999'; //
  MedicationSchedule = '/petType/{PetTypeKey}/medication/schedule?size=100&sort=orderId,asc'; //
  petMedication = '/petMedication'

  token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDk1MDYyMzkyMzYsInVzZXJfbmFtZSI6InVhdEBzdWl0ZXBhd3MuY29tIiwicm9sZXMiOlsiT1JHQU5JWkFUSU9OX0FETUlOIl0sImF1dGhvcml0aWVzIjpbIk9SR0FOSVpBVElPTl9BRE1JTiJdLCJjbGllbnRfaWQiOiJhcHBfdXNlciIsImZpcnN0TmFtZSI6IlVBVEFkbWluIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIk9SR0FOSVpBVElPTl9BRE1JTiJdLCJvcmdhbml6YXRpb24iOiJPUkdfU1VJVEVQQVdTIiwiaWQiOiIwMDAwMDEiLCJ1c2VyVHlwZSI6IkVNUExPWUVFIiwiZXhwIjoxNjc4MDM5Mjg3LCJ0ZW1wUGFzc3dvcmQiOmZhbHNlLCJqdGkiOiJlYjNiMWU0MS05MzdlLTQxZDktYjY1ZS03MWM1Y2FkOTUyYjMiLCJlbWFpbCI6InVhdEBzdWl0ZXBhd3MuY29tIiwidGVuYW50Ijoic3VpdGVwYXdzIiwic3RhdHVzIjp7ImNvZGUiOjEwMDAsIm1lc3NhZ2UiOiJTdWNjZXNzIiwic2hvdWxkRGlzcGxheSI6ZmFsc2V9fQ.uT0hvOM1nh131k7yBIAA4JOZWMA878XAwI99Yayxrho'


  constructor(private http: HttpClient, public appService: AppService) {

  }
  orgKey;
  tenant;
  // https://uat.runloyal.com/services/user-service/api/v2/suitepaws/XJSDFA1/petType/4/feed/feedAmount?size=100&sort=orderId,asc

  // https://uat.runloyal.com/services/user-service/api/v2/suitepaws/XJSDFA1/petType/4/feed/feedSchedule?size=100&sort=orderId,asc

  baseUrlv3 = `${this.appService.userServiceUrl}/api/v3/`;

  APP_PROFILE_SETTINGS = this.baseUrlv3 + "{{organizationKey}}/{{tenant}}/{{userKey}}/app-profile-setting?size=300&platform=WEB";
  addPetKey(value) {
    this.petKey.push(value);
    console.log(this.petKey);
  }

  getAppProfileSettings() {
    if (localStorage.getItem("tenant")) {
      this.tenant = localStorage.getItem("tenant");
    }
    if (localStorage.getItem("organizationKey")) {
      this.orgKey = localStorage.getItem("organizationKey");
    }
    this.tenant = this.tenant.replace(/['"]/g, '');
    this.token = this.getToken().replace(/['"]/g, '');
    let userKey = this.getUserKey().replace(/['"]/g, '');

    let url = this.APP_PROFILE_SETTINGS.replace('{{organizationKey}}', this.orgKey).replace("{{userKey}}", userKey).replace("{{tenant}}", this.tenant);

    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    return this.http.get(url, { headers: myHeaders })
  }

  getPetTypeId(ID) {
    this.petTypeId = ID;
  }
  setTenantKey(tenant) {
    this.client = tenant;
  }
  getToken() {
    if(localStorage.getItem('token')) {
      return localStorage.getItem('token')
    }
    return ""
  }
  getUserKey() {
    return localStorage.getItem('userKey');
  }
  getLocationKey() {
    return this.appService.storageService.getItem("locationKey")
  }

  DeleteCard(id) {
    // let token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDk0NzY3OTQ3NzEsInVzZXJfbmFtZSI6InVhdEBzdWl0ZXBhd3MuY29tIiwicm9sZXMiOlsiT1JHQU5JWkFUSU9OX0FETUlOIl0sImF1dGhvcml0aWVzIjpbIk9SR0FOSVpBVElPTl9BRE1JTiJdLCJjbGllbnRfaWQiOiJhcHBfdXNlciIsImZpcnN0TmFtZSI6IlVBVEFkbWluIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIk9SR0FOSVpBVElPTl9BRE1JTiJdLCJvcmdhbml6YXRpb24iOiJPUkdfU1VJVEVQQVdTIiwiaWQiOiIwMDAwMDEiLCJ1c2VyVHlwZSI6IkVNUExPWUVFIiwiZXhwIjoxNjc4MDA5ODQyLCJ0ZW1wUGFzc3dvcmQiOmZhbHNlLCJqdGkiOiJmNDkzZjcwMi01NjRkLTRhZjItOTJiYi1mOTlmYjAyYTUxNTEiLCJlbWFpbCI6InVhdEBzdWl0ZXBhd3MuY29tIiwidGVuYW50Ijoic3VpdGVwYXdzIiwic3RhdHVzIjp7ImNvZGUiOjEwMDAsIm1lc3NhZ2UiOiJTdWNjZXNzIiwic2hvdWxkRGlzcGxheSI6ZmFsc2V9fQ.MNzsfc1Hn2rAobOMGEqdOAldjoH5hXAgSsQrIWXN8z8'
    this.token = this.getToken().replace(/['"]/g, '');
    let userKey = this.getUserKey().replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseCardUrl + this.appKey + `/merchant/${this.client}/customer/${userKey}/cards/` + id;

    // let url='https://uat.runloyal.com/services/payment-service/api/iTrust-PawOps/merchant/suitepaws/customer/JMNAR17355/cards/'+id;
    return this.http.delete(url, { headers: myHeaders })
  }

  GetCard() {
    this.token = this.getToken().replace(/['"]/g, '');
    let userKey = this.getUserKey().replace(/['"]/g, '');

    let url = this.baseCardUrl + this.appKey + `/merchant/${this.client}/customer/${userKey}/cards`;

    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    return this.http.get(url, { headers: myHeaders })
  }
  // Pet Type Data store
  storePetType(data) {
    this.petType = data;
    console.log(this.petType, '$-PetType');
  }
  getPetInfo() {
    return this.petKey;
  }

  storeAppointment(appointment, userId) {
    this.appointmentObj = appointment;
    this.userId = userId;
    console.log('$-AppointmentStorage', this.appointmentObj, this.userId);
  }

  assignQuestionToPet(reservationServiceType: any, details: any, pet:petKeyInfo) {

    pet.answers = pet.answers || new Map<string, questions[]>();

    reservationServiceType.forEach(service => {
      const reservationId = service.id;
      const reservationName = service.name;
      const appointmentCount = details.pet.appointmentCount;

      if (service.hasOwnProperty('questions') && service.questions.length > 0) {

        // transform questions and push it to any array
        service.questions.forEach(question => {
          console.log(question,"q");
          
          const newQuestion: questions = {
            reservationId: reservationId,
            fullQuestion: question.question,
            question: { id: question.id }, // Set the id to the desired number
            answer: "" // Set the answer to your desired string
          };
          // first and every
          if (appointmentCount == 0) {
            if (question.firstTimeCustomer || question.newAppointment) {
              if (pet.answers.has(reservationName)) {
                pet.answers.get(reservationName).push(newQuestion);
              } else {
                pet.answers.set(reservationName, [newQuestion]);
              }
            }
          } else {
            if (question.newAppointment) {
              if (pet.answers.has(reservationName)) {
                pet.answers.get(reservationName).push(newQuestion);
              } else {
                pet.answers.set(reservationName, [newQuestion]);
              }
            }
          }
        })
      }
      else if(service.linkedReservationTypeId && service.linkedReservationTypeId > 0){
        this.appService.getLinkedServiceQuestion(service.linkedReservationTypeId).subscribe(
          res => {
            console.log(res)
            if(res['list'] && res['list'].length > 0){  
              service.questions = res['list']
              service.questions.forEach(question => {
                console.log(question,"q");
                
                const newQuestion: questions = {
                  reservationId: reservationId,
                  fullQuestion: question.question,
                  question: { id: question.id }, // Set the id to the desired number
                  answer: "" // Set the answer to your desired string
                };
                // first and every
                if (appointmentCount == 0) {
                  if (question.firstTimeCustomer || question.newAppointment) {
                    if (pet.answers.has(reservationName)) {
                      pet.answers.get(reservationName).push(newQuestion);
                    } else {
                      pet.answers.set(reservationName, [newQuestion]);
                    }
                  }
                } else {
                  if (question.newAppointment) {
                    if (pet.answers.has(reservationName)) {
                      pet.answers.get(reservationName).push(newQuestion);
                    } else {
                      pet.answers.set(reservationName, [newQuestion]);
                    }
                  }
                }
              })
            }
          },
          error => {
            console.log("error", error);
          }
        );

      }
    })
  }

  forceCheck(): Observable<forceControl> {

    this.petKey.forEach(element => {
      // console.log(this.appointmentObj, "Appointment Obj");
      
      let appointmentArr = this.appointmentObj.appointmentDetails.filter(details => {
        console.log(details, element.petKey);
        if (details.pet.petKey === element.petKey) {

          this.assignQuestionToPet(details.reservationTypes, details, element);

          return true;
        } else {
          false;
        }
      })
     

      console.log('$-arr', appointmentArr, element);

      let reservationArr = this.petType.filter(type => {
        if (type.id == element.typeID) {
          return true;
        } else {
          false;
        }
      });

      element.ForceFeeding = this.check(appointmentArr[0].reservationTypes, reservationArr[0].reservationTypes, 'forceFeeding')
      element.ForceMedication = this.check(appointmentArr[0].reservationTypes, reservationArr[0].reservationTypes, 'forceMedication')
      element.ForceCardOnFile = this.check(appointmentArr[0].reservationTypes, reservationArr[0].reservationTypes, 'forceCardonFile')

      console.log(element);

    });

    this.updateForceControl();

    return new Observable<any>(observer => {
      observer.next(true);
    });

  }
  savedCard = false;
  updateForceControl() {
    this.ForceStepperControl.ForceFeeding = this.updateForceControlCheck('ForceFeeding');
    this.ForceStepperControl.ForceMedication = this.updateForceControlCheck('ForceMedication');
    this.ForceStepperControl.ForceCardOnFile = this.updateForceControlCheck('ForceCardOnFile');
    this.savedCard = this.updateForceControlCheck('ForceCardOnFile');
  }

  updateForceControlCheck(type): boolean {
    return this.petKey.some(pet => {
      return pet[type];
    })
  }

  check(appointmentArr, reservationArr, type): boolean {

    return appointmentArr.some(element => {
      let resArrFilter = reservationArr.filter(resElement => {
        return parseInt(element.id) == resElement.id;
      })
      return resArrFilter[0][type];
    })

  }




  AddCard(data) {
    this.token = this.getToken().replace(/['"]/g, '');
    let userKey = this.getUserKey().replace(/['"]/g, '');

    let url = this.baseCardUrl + this.appKey + `/merchant/${this.client}/customer/${userKey}/addCard`;
    // https://uat.runloyal.com/suitepaws/cardSaved.html
    // data.applicationReturnUrl = this.basePath+this.client+'/cardSaved.html';
    data.applicationReturnUrl = window.location.href + "cardadd"

    console.log(url);

    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    return this.http.post(url, data, { headers: myHeaders })
  }

  MedPost(data, index) {
    this.token = this.getToken().replace(/['"]/g, '');
    let locationKey = this.getLocationKey().replace(/['"]/g, '');
    this.petId = this.petKey[index].petKey;

    let url = this.baseUrl + this.client + `/${locationKey}/petMedication/` + this.petId;
    console.log(url);

    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    console.log(data);

    if (data.id == -1) {
      delete data.id;
      console.log(data);

      return this.http.post(url, data, { headers: myHeaders })
    }
    return this.http.put(url, data, { headers: myHeaders })

  }
  FeedPost(data, index) {

    this.token = this.getToken();
    this.token = this.token.replace(/['"]/g, '');
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.petId = this.petKey[index].petKey;
    let url = this.baseUrl + this.client + `/${locationKey}/petFeed/` + this.petId;
    console.log(url);

    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    console.log(data);

    if (data.id == -1) {
      delete data.id;
      console.log(data);

      return this.http.post(url, data, { headers: myHeaders })
    }
    return this.http.put(url, data, { headers: myHeaders })

  }

  public petMed(petKey: string) {
    this.token = this.getToken();
    this.petId = petKey.replace(/['"]/g, '');
    this.token = this.token.replace(/['"]/g, '');
    let locationKey = this.getLocationKey().replace(/['"]/g, '');


    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });

    let url = this.baseUrl + this.client + `/${locationKey}/${this.petId}/petMedication`;
    console.log(url);
    return this.http.get(url, { headers: myHeaders })
  }

  public petFeed(petKey: string) {

    console.log(petKey);

    this.token = this.getToken();
    // this.petId=this.petKey[0];
    this.token = this.token.replace(/['"]/g, '');
    let locationKey = this.getLocationKey().replace(/['"]/g, '');


    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });

    let url = this.baseUrl + this.client + `/${locationKey}/` + petKey.replace(/['"]/g, '') + '/petFeed';
    console.log(url);
    return this.http.get(url, { headers: myHeaders })
  }
  public MedSch() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.MedicationSchedule.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public feedSch() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.feedSchUrl.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public MedType() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.MedicationType.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public feedType() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.feedtype.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public feedMethod() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.feedmethod.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public MedAmt() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.MedicationAmount.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }

  public feedAmt() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.feedAmount.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public MedUnit() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.MedicationUnit.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  public feedUnits() {
    this.token = this.getToken();
    // this.petId=this.petKey[0];
    let locationKey = this.getLocationKey().replace(/['"]/g, '');

    this.token = this.token.replace(/['"]/g, '');
    let myHeaders = new HttpHeaders({
      "Authorization": `Bearer ${this.token}`,
      "Content-Type": "application/json",
    });
    let url = this.baseUrl + this.client + `/${locationKey}` + this.feedUnit.replace('{PetTypeKey}', this.petTypeId);
    return this.http.get(url, { headers: myHeaders });
    // return this.http.get(url,{headers:{
    //   'Authorization':" Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuX2V4cGlyZXNfaW4iOjE3MDkxMjE3NDQzMzcsInVzZXJfbmFtZSI6ImRhdHVyYSszNjlAcnVubG95YWwuY29tIiwicm9sZXMiOm51bGwsImF1dGhvcml0aWVzIjpbIkxBX1JXIiwiQURNSU4iLCJMQV9SIiwiVVNFUiIsIk9SR0FOSVpBVElPTl9BRE1JTiIsIkVNUExPWUVFIl0sImNsaWVudF9pZCI6ImFwcF91c2VyIiwiZmlyc3ROYW1lIjoiRGF0dXJhIiwiYXVkIjpbImtlbm5lbC91c2VyIl0sInNjb3BlIjpbIlVTRVIiLCJBRE1JTiIsIkVNUExPWUVFIiwiT1JHQU5JWkFUSU9OX0FETUlOIiwiTEFfUlciLCJMQV9SIl0sIm9yZ2FuaXphdGlvbiI6Ik9SR19TVUlURVBBV1MiLCJpZCI6IkFVQlRFMTc1MTkiLCJ1c2VyVHlwZSI6IlVTRVIiLCJleHAiOjE2Nzc2NTQ3OTIsInRlbXBQYXNzd29yZCI6ZmFsc2UsImp0aSI6ImRmZmZlYmM3LTFlZjItNDcwOS1iZDdhLTQzODI3ZDc2MDQxYyIsImVtYWlsIjoiZGF0dXJhKzM2OUBydW5sb3lhbC5jb20iLCJ0ZW5hbnQiOiJzdWl0ZXBhd3MiLCJzdGF0dXMiOnsiY29kZSI6MTAwMCwibWVzc2FnZSI6IlN1Y2Nlc3MiLCJzaG91bGREaXNwbGF5IjpmYWxzZX19.Dmool7eNx7S4ytNh_2k4Wb_mUNaain3Ci6dtZB6gUfw"
    // }});
  }
  pet_names: string = "";
  start_time_str: string = "";
  end_time_str: string = "";
  displayAddress: string = "";

  setConfirmationValue(pet_names, start_time_str, end_time_str, displayAddress,showEndTimeInSummary) {
    localStorage.setItem('pet_names', pet_names);
    localStorage.setItem('start_time_str', start_time_str);
    localStorage.setItem('end_time_str', end_time_str);
    localStorage.setItem('displayAddress', displayAddress);
    localStorage.setItem('showEndTimeInSummary', showEndTimeInSummary);
  }

  getAddCardLink(key:any,value:string){
    // payment-service/payment-gateway-urls/payment-platform?petOwnerKey=poKey
    let url = this.appService.baseUrl + `/payment-service/payment-gateway-urls/payment-platform?${key}=${value}`+`&tenantKey=${this.appService.tenantKey}`;
    return this.http.get(url);
  }

  getCardTokenCallBack(url:any){
    return this.http.get(url);
  }

  getAppointmentDetail(appointmentKey:any){
    let url = this.appService.baseUrl + `/user-service/admin/v1/${this.appService.tenantKey}//appointments/${appointmentKey}`;
    return this.http.get(url);
  }

  storeCard(referenceId:any){
    let url = this.appService.baseUrl + `/payment-service/api/iTrust-PawOps/merchant/${this.appService.tenantKey}/referenceId/${referenceId}/storeCard`;
    return this.http.post(url,'');
  }




}
